import { queryOptions } from '@tanstack/react-query';

import { http } from '@/services/http';

import { gxQueryKey, toCatalogueItem } from '../lib/gxCodes';

export function catalogQueryOptions(code: string) {
  return queryOptions({
    queryKey: gxQueryKey(code),
    queryFn: async () => {
      const resp = await http.data.get(`/catalogue?Code=${code}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          fields: 'Title,Code,Alias,Currency,Units,PeriodType,Period,TimeRef'
        }
      });
      return toCatalogueItem(resp.data);
    },
    enabled: Boolean(code)
  });
}
